import { motion } from "framer-motion";
import { MANIFESTE } from "@/data/site";
import { SectionHead } from "@/components/site/Reveal";

export const Manifeste = () => (
  <section id="approche" className="relative py-24 md:py-36" data-testid="manifeste-section">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHead
        label="Manifeste"
        title={
          <>
            Nous ne créons pas des sites.{" "}
            <span className="text-gradient">Nous créons votre présence en ligne.</span>
          </>
        }
        subtitle="Chaque projet est construit autour de votre activité, vos objectifs, votre clientèle, votre image de marque, le parcours utilisateur, le référencement et les performances. Trois raisons de nous confier la création de votre site internet."
      />

      <div className="flex flex-col gap-20 md:gap-28">
        {MANIFESTE.map((item, i) => (
          <div
            key={item.num}
            className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}
            data-testid={`manifeste-chapter-${item.num}`}
          >
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="lg:[direction:ltr]"
            >
              <div className="flex items-baseline gap-5 mb-5">
                <span className="font-display font-extrabold text-6xl md:text-7xl text-transparent" style={{ WebkitTextStroke: "1.5px rgba(139,92,246,0.5)" }}>
                  {item.num}
                </span>
                <span className="font-mono-label text-[10px] tracking-[0.25em] uppercase text-[var(--accent-cyan)]">
                  {item.label}
                </span>
              </div>
              <h3 className="font-display font-bold text-3xl md:text-4xl tracking-tight">{item.title}</h3>
              <p className="text-[var(--text-secondary)] text-base md:text-lg mt-5 leading-relaxed max-w-xl">
                {item.text}
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="lg:[direction:ltr]"
            >
              <div className="relative rounded-2xl overflow-hidden border border-white/[0.09] group">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[16/10] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#03040b]/70 to-transparent" />
              </div>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifeste;
